import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import { StateType } from 'typesafe-actions';
import { betsReducer } from './bets/reducer';
import { bookiesReducer } from './bookies/reducer';
import { dashboardReducer } from './dashboard/reducer';
import { loginReducer } from './login/reducer';
import { marketsReducer } from './markets/reducer';
import { matchesReducer } from './matches/reducer';
import { meReducer } from './me/reducer';
import { ownedBetsReducer } from './ownedBets/reducer';
import { paymentsReducer } from './payments/reducer';
import { premiumInfoReducer } from './premium/reducer';
import { pricingInfoReducer } from './pricing/reducer';
import { sportsReducer } from './sports/reducer';
import { TipsInfoReducer } from './tips/reducer';
import { tipsterReducer } from './tipster/reducer';
import { worldCupMatchesReducer } from './worldCupMatches/reducer';
import { worldCupRankingsReducer } from './worldCupRankings/reducer';
import { competitionsReducer } from './competitions/reducer';
import { tipsterPreferencesReducer } from './tipsterPreferences/reducer';
import { settingsReducer } from './settings/reducer';
import { channelsReducer } from './channels/reducer';

export const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    login: loginReducer,
    tipster: tipsterReducer,
    bets: betsReducer,
    ownedBets: ownedBetsReducer,
    matches: matchesReducer,
    payments: paymentsReducer,
    me: meReducer,
    markets: marketsReducer,
    bookies: bookiesReducer,
    sports: sportsReducer,
    premiumInfo: premiumInfoReducer,
    tipsInfo: TipsInfoReducer,
    dashboard: dashboardReducer,
    pricing: pricingInfoReducer,
    worldCupMatches: worldCupMatchesReducer,
    worldCupRankings: worldCupRankingsReducer,
    competitions: competitionsReducer,
    tipsterPreferences: tipsterPreferencesReducer,
    settings: settingsReducer,
    channels: channelsReducer,
  });

export type RootState = StateType<ReturnType<typeof rootReducer>>;

export default rootReducer;
